import type { ReviewedLibraryIdentity } from './library-identity-types';

export const LIBRARY_ABS_01: ReviewedLibraryIdentity[] = [
  {
    "id": "library-home-side-plank-v2",
    "name": "哥本哈根侧支撑",
    "group": "abs",
    "subCategory": "obliques",
    "equipment": "bodyweight",
    "pattern": "侧向抗屈及髋内收支撑",
    "legacyIds": [
      "home-side-plank-v2",
      "fanjue-copenhagen-plank"
    ],
    "sourceId": "course-20261008-fanjue-plan-15-05",
    "targetMuscles": [
      "腹斜肌",
      "核心肌群",
      "髋内收肌群"
    ],
    "evidence": "居家侧支撑实为上侧腿搭支撑物的哥本哈根支撑；同模式只保留一个核心动作"
  },
  {
    "id": "library-personal-s7-hanging-leg-raise",
    "name": "悬垂举腿",
    "group": "abs",
    "subCategory": "lower-abs",
    "equipment": "bodyweight",
    "pattern": "悬垂骨盆卷曲及髋屈",
    "legacyIds": [
      "personal-s7-hanging-leg-raise"
    ],
    "sourceId": "course-20261008-personal-07-01",
    "targetMuscles": [
      "腹直肌",
      "髋屈肌群"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-personal-s7-crunch",
    "name": "仰卧卷腹",
    "group": "abs",
    "subCategory": "upper-abs",
    "equipment": "bodyweight",
    "pattern": "仰卧躯干屈曲",
    "legacyIds": [
      "personal-s7-crunch"
    ],
    "sourceId": "course-20261008-personal-07-02",
    "targetMuscles": [
      "腹直肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-personal-s7-ab-wheel",
    "name": "跪姿健腹轮",
    "group": "abs",
    "subCategory": "core",
    "equipment": "ab-wheel",
    "pattern": "跪姿抗伸展",
    "legacyIds": [
      "personal-s7-ab-wheel"
    ],
    "sourceId": "course-20261008-home-02-05",
    "targetMuscles": [
      "腹直肌",
      "腹横肌",
      "核心稳定肌群"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-fanjue-reverse-hyperextension-crunch",
    "name": "反向山羊挺身卷腹",
    "group": "abs",
    "subCategory": "lower-abs",
    "equipment": "bodyweight",
    "pattern": "支撑位骨盆卷曲",
    "legacyIds": [
      "fanjue-reverse-hyperextension-crunch"
    ],
    "sourceId": "course-20261008-fanjue-plan-13-01",
    "targetMuscles": [
      "腹直肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-fanjue-cable-crunch-kneeling",
    "name": "跪姿绳索卷腹",
    "group": "abs",
    "subCategory": "upper-abs",
    "equipment": "cable",
    "pattern": "跪姿负重躯干屈曲",
    "legacyIds": [
      "fanjue-cable-crunch-kneeling"
    ],
    "sourceId": "course-20261008-fanjue-plan-13-03",
    "targetMuscles": [
      "腹直肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-fanjue-cable-twist",
    "name": "绳索躯干旋转",
    "group": "abs",
    "subCategory": "obliques",
    "equipment": "cable",
    "pattern": "负重躯干旋转",
    "legacyIds": [
      "fanjue-cable-twist"
    ],
    "sourceId": "course-20261008-fanjue-plan-15-04",
    "targetMuscles": [
      "腹内斜肌",
      "腹外斜肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  }
];
